
import { StyleEntry } from 'Shared/backend/styleUtils';
import { theme, palette } from 'Shared/frontend/SettingsProvider';
import { resolveColour } from 'Shared/model/settingColour';
import { ColourFields } from 'Shared/themes/Colour';
import { stickyStyle } from 'Shared/frontend/nav/StandardNavWithLogo';

export function navStyles(sizes,text): {[name: string]: StyleEntry}
{
	return {
		'Fade in background': {
			explanation: "Show the nav background only when the page is scrolled down from the top. The colour is the one it fades up to - leave it unset to use the nav bar's own background colour.",
			ui: ColourFields,

			rules: [{
				location: () => ['nav','desktop'],
				css: (params = {}, atTop: boolean) => ({
					...stickyStyle(),
					position: 'fixed',
					transition: 'background-color 0.7s',
					backgroundColor: atTop ? 'rgba(0,0,0,0)'
						: resolveColour(params.colour, palette()) || theme().nav.desktop.settings.outer.backgroundColor
				})
			}]
		},

		'Hide on desktop': {
			explanation: 'Hides the desktop navigation bar.',

			rules: [{
				location: () => ['nav','desktop'],
				hide: () => true
			}]
		},

		'Hide on mobile': {
			explanation: 'Hides the mobile navigation buttons.',

			rules: [{
				location: () => ['nav','mobile'],
				hide: () => true
			}]
		}
	};
}

